import * as React from 'react'

export const TextWithTitle = ({text}: { text: string }) => {
    return <span title={text}>{text}</span>
}